<template>
  <router-view/>
</template>

<style>



body,button,input,option,select,textarea {
  /*font-size: 13px;*/
  color: #000;
  font-family: 'Open Sans',Arial,Helvetica,Verdana,sans-serif;
  text-align: left;
  -webkit-text-size-adjust: 100%
}

.modal-header,
.modal-footer {
  border: none;
}

input {
  font-family: 'Open Sans',Arial,Helvetica Neue,Helvetica,sans-serif;
}

/* SITE.CSS */

a {
  color: #1a6dbb;
  text-decoration: none;
}
img {
  max-width: 100%;
}

h1 {
  font-size: 20px;
  /* font-size: initial; */
  font-weight: bold;
  line-height: 1.2;
  color: #333;
  font-weight: normal;
  font-family: Roboto;
  text-align: center;
}

h2 {
  line-height: 1.5;
  color: #333;
  font-weight: normal;
}

a:hover {
  text-decoration: none;
}


menu {
  padding: 0;
  margin: 0;
}

.menu_top {
  overflow: hidden;
}

.menu_top li {
  list-style-type: none;
  float: left;
  box-sizing: border-box;
  /* background: #4a3e66; */
  /* display: none; */
}

.menu_top a {
  color: rgba(255, 255, 255, 0.54);
  font-weight: 500;
  display: block;
  padding: 16.5px 10px;
  /* text-transform: uppercase; */
  font-size: 90%;
}

.menu_top li a:hover {
  opacity: 1;
  color: #fff;
  background: #ffffff0a;
}

.menu_top-home_link {
  display: block;
  float: left;
  /* width: 100%; */
  /* background: #4a3e66; */
}

.menu_top-home_link a {
  color: #eee;
  font-weight: 500;
}

#logo-menu {
  padding: 5px 5px 5px 10px;
  float: left;
  /* padding-bottom: 0; */
  width: 55px;
  margin-left: 10px;
}

.container.header {
  background: #333;
}

#logo-menu .st0 {
  fill: #fff;
}

#logo-menu .st1 {
  fill: #fff;
}

#logo-menu .st2 {
  fill: #333;
}

#logo-menu .st2:last-child {
  fill: none;
}

@media screen and (min-width: 900px) {

  .menu_top li {
    list-style-type: none;
    float: left;
    box-sizing: border-box;
    padding: 0;
    background: transparent;
    margin: 0;
    display: block;
  }

  .menu_top li a {
    padding: 15px 15px 15px 15px;
    display: block;
    color: #000;
    opacity: 1;
    /* text-transform: uppercase; */
    transition: .2s;
    font-weight: 400;
    font-size: 15px;

  }

  .menu_top li a:hover {
    opacity: 1;
    color: #2a9d3d;
  }

  ul {
    padding: 0;
    margin: 0;
    display: block;
    -webkit-margin-after: 1em;
  }

  ul li {
    display: list-item;
  }

  ul.inline-items li {
    min-width: 7%;
    margin-right: 5%;
  }

  .menu li {
    display: inline-block;
    width: 11%;
    padding: 0 2px;
    float: left;
    box-sizing: border-box;
  }

  .menu ul li a, .menu .hentry a {
    display: block;
    margin-bottom: 4px;
    margin: 3px;
    margin-right: 6px;
    margin-left: 0;
    background: #fff;
    color: #3e4753;
    font-weight: normal;
    border-radius: 3px;
    transition: .2s;
    box-shadow: none;
  }

  .menu ul li a:hover, .menu .hentry a:hover {
    z-index: 99;
    box-shadow: none;
    position: relative;
    background: #fff;
  }

  .container.header {
    background: #fff;
  }

  #logo-menu {
    float: left;
    padding-bottom: 0;
    width: 61px;
  }

  #logo-menu * {
    transition: .5s;
  }

  #logo-menu .st0 {
    fill: black;
  }

  #logo-menu .st1 {
    fill: #31b647;
  }

  #logo-menu .st2 {
    fill: black;
    opacity: .25;
  }

  #logo-menu:hover .st1 {
    fill: #219734;
  }

  /*
  ** style of market
  */


  /*
  ** END style of market END
  */


}

.content i,
.content em {
  color: #3e4753;
  border-bottom: 1px solid #aaa;
  padding-bottom: 2px;
  font-style: normal;
}

@keyframes pulse-i {
  from {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  to {
    transform: scale(1);
  }
}

.inst {
  text-align: center;
  background: #f5f5f5;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.inst a {
  color: #ff6d45;
  animation: pulse-i 1.5s 2 cubic-bezier(0.55, 0, 0.2, 1.06);
  display: block;
  width: max-content;
  margin: 0 auto;
  margin-top: 5px;
}

.inst a:hover {
  text-decoration: underline;
}

.body_auth {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #263238;
}

.wrapper_auth_page {
  width: 250px;
}

.wrapper_auth_page .icon-header {
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.wrapper_auth_page #logo-menu {
  margin: 0;
  padding: 0;
}

.wrapper_auth_page #logo-menu .st1,
.wrapper_auth_page #logo-menu .st0 {
  fill: #fff;
}

.wrapper_auth_page #logo-menu .st2 {
  fill: #000;
  opacity: .25;
}

.wrapper_auth_page .form-group {
  margin: 0;
}

.wrapper_auth_page .form-control {
  border-radius: 0;
  border: none;
}

.wrapper_auth_page .form-control:focus {
  outline: none;
  box-shadow: none;
  border: none;
}

.wrapper_auth_page .form-group:first-child .form-control {
  border-bottom: 1px solid #eee;
  border-radius: 2px 2px 0 0;
}

.wrapper_auth_page .form-group:last-child .form-control {
  border-bottom: none;
  border-radius: 0 0 2px 2px;
}

.header_auth_page {
}

.btn-auth {
  margin-top: 10px;
  width: 100%;
  border-radius: 2px;
  background-color: #4CAF50;
  color: #fff;
  border: none;
  padding: 7px 0;
}

.btn-auth:hover, .btn-auth:focus, .btn-auth.focus {
  color: #fff;
  text-decoration: none;
  outline: none;
}

.btn-auth:active {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  text-decoration: none;
  outline: none;
}

/* MARKET.CSS */

.fa {
  text-decoration: none !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
  color: inherit !important;
}

.serach_list::-webkit-scrollbar {
  width: 6px;
  height: 3px;
  padding-right: 3px;
  background: transparent;
}

.serach_list::-webkit-scrollbar-button {
  background-color: #666;
  display: none;
  background: transparent;
}

.serach_list::-webkit-scrollbar-track {
  background-color: #999;
  background: transparent;
}

.serach_list::-webkit-scrollbar-track-piece {
  background: transparent;
}

.serach_list::-webkit-scrollbar-thumb {
  height: 50px;
  background-color: #25273236;
  border-radius: 3px;
}

.serach_list::-webkit-scrollbar-corner {
  background-color: #999;
  background: transparent;
}

.serach_list::-webkit-resizer {
  background-color: #25273236;
  background: transparent;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

*, html {
  font-family: 'Proxima Nova Regular';
}

*,
*:hover,
*:focus,
*:active {
  outline: none !important;
}

@font-face {
  font-family: 'Proxima Nova Extra Bold';
  src: url('/fonts/ProximaNova-Extrabld.eot');
  src: url('/fonts/ProximaNova-Extrabld.eot?#iefix') format('embedded-opentype'),
  url('/fonts/ProximaNova-Extrabld.woff') format('woff'),
  url('/fonts/ProximaNova-Extrabld.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Proxima Nova Bold';
  src: url('/fonts/ProximaNova-Bold.eot');
  src: url('/fonts/ProximaNova-Bold.eot?#iefix') format('embedded-opentype'),
  url('/fonts/ProximaNova-Bold.woff') format('woff'),
  url('/fonts/ProximaNova-Bold.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Proxima Nova Regular';
  src: url('/fonts/ProximaNova-Regular.eot');
  src: url('/fonts/ProximaNova-Regular.eot?#iefix') format('embedded-opentype'),
  url('/fonts/ProximaNova-Regular.woff') format('woff'),
  url('/fonts/ProximaNova-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

b {
  /* font-weight: normal; */
  font-family: 'Proxima Nova Extra Bold';
}

body#body {
  font-family: 'Proxima Nova Regular';
  background: transparent;
  padding: 0;
}

.header {
  /* border-bottom: 1px solid #eee; */
  background: #252732;
}

.header .container {
  padding: 10px;
}

.menu_top li a {
  color: #fff;
}

.menu_top li a:hover {
  text-decoration: none;
  color: #31b647;
  background: transparent;
}

#logo-menu .st1,
#logo-menu .st0 {
  fill: #fff;
}

#logo-menu .st2 {
  fill: #000;
}

.wrapper {
  border: none;
  box-shadow: none;
  transition: none;
  margin-bottom: 0;
}

input {
  padding: 5px 12px;
  border: 1px solid #ccc;
  transition: .2s;
}

input:focus {
  border-color: transparent;
  border-bottom-color: #31b64787;
  border-bottom-width: 1px;
}

input:disabled {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
  user-select: none;
}

.footer {
  padding: 0;
  margin: 0;
  width: 100%;
  max-width: initial;
  background: #252732;
}

.footer .site_info li {
  color: #e9eaeb;
}

.footer .site_info a {
  color: #31b647;
}

.hide {
  display: none;
}

.wrapper {
  width: auto;
}

.container {
  padding: 0 20px 0;
  position: initial;
}

.b-market-desc {
  color: #262c36;
  font-size: 16px;
}

.content {
  margin: 0;
}

.content-header {
  padding: 40px 0;
}

h1 {
  font-size: 35px;
  font-family: 'Proxima Nova Extra Bold';
}

h2 {
  font-family: 'Proxima Nova Regular', sans-serif;
}

h1, h2 {
  color: #262c36;
}

h3.title-block {
  font-family: 'Proxima Nova Extra Bold', sans-serif;
  margin-bottom: 25px;
}

h4.title-block {
  font-size: 20px;
}

h4 {
  font-family: 'Proxima Nova Bold', sans-serif;
}

.b-black {
  background-color: #ECEFF1;
}

.header-content h1,
.header-content h2 {

}

.b-sum-check {
  /* background: #f1f1f1; */
  user-select: none;
  color: #262c36;
  border-bottom: 1px solid #eee;
}

.b-sum-check-t {
  font-family: 'Proxima Nova Extra Bold';
}

.btn-primary.to-back {
  background: transparent;
  color: #31b647;
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #252732e8;
  background-color: #f1f1f1;
  border-color: transparent;
}

.btn-primary.disabled:hover,
.btn-primary:disabled:hover {
  color: #252732e8;
  background-color: #f1f1f1;
  border-color: #2527324a;
}

.btn-primary {
  color: #fff;
  background-color: #31b647;
  border-color: #31b647;
  font-family: 'Proxima Nova Bold';
  font-size: 16px;
  border-radius: unset;
}

.btn-primary:hover {
  color: #fff;
  background-color: #17922b;
  border-color: #17922b;
}

.btn-primary.focus, .btn-primary:focus {
  box-shadow: 0 0 0 0.2rem rgba(49, 182, 71, 0.28);
}

.btn-primary:not(:disabled):not(.disabled).active:focus,
.btn-primary:not(:disabled):not(.disabled):active:focus,
.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(49, 182, 71, 0.28);
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #117b22;
  border-color: #117b22;
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {

}

.b-nav-order-step .container {
  padding: 10px 0;
}

.b-nav-order-step {
  text-align: center;
}

/*
.b-nav-order-step {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  margin: 0;
}
.b-nav-order-step .container {
  padding-top: 10px;
  padding-bottom: 10px;
}
*/

.btn-form {
  transition: .2s;
  font-family: 'Proxima Nova Regular';
  font-size: 17px;
  cursor: pointer;
  color: #fff;
  background-color: #31b647;
  border-color: #31b647;
  padding: 0.7rem 4rem;
  line-height: 1.5;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  border: none;
  border-radius: 3px;
  /* box-shadow: 0 0 0px 1px red; */
  padding: 10px 45px 10px 45px;
  width: max-content;
  box-shadow: 0 9px 8px -2px rgba(255, 109, 69, 0.45);
}

.btn-form:hover,
.btn-form:active {
  background-color: #17922b;
  border-color: #17922b;
}

.btn-form:disabled,
.btn-form:disabled:hover {
  background-color: #f6f6f6;
  color: #7e7f85;
  box-shadow: none;
}

.btn-finaly,
.btn-finaly:hover {
  background-color: #ff6d45;
  color: #fff;
}

.btn-finaly:hover {
  background-color: #ff5526;
  border-color: #ff5526 !important;
}

.btn-finaly.focus, .btn-finaly:focus {
  background-color: #ff5526;
  border-color: #ff5526;
  outline: none !important;
}

.btn-finaly:not(:disabled):not(.disabled).active,
.btn-finaly:not(:disabled):not(.disabled):active,
.show > .btn-finaly.dropdown-toggle {
  color: #fff;
  background-color: #f45327;
  border-color: #ff5526;
  outline: none !important;
  box-shadow: 0 4px 4px -2px rgba(255, 109, 69, 0.45);
}

.btn-finaly:focus {
  background-color: #ff5526;
}

.b-progress-order {

}

.b-progress-contain {
  width: 100%;
  height: 5px;
  background: #f1f1f1;
  content: ' ';
}

.progress-line {
  height: 100%;
  background: #31b647;
  transition: .5s;
}

@keyframes pulse-animation {
  0% {
    opacity: 1;
    transform: scale(1)
  }

  80% {
    opacity: 1;
    transform: scale(1.5);
    border-radius: 3px;
  }

  to {
    opacity: 1;
    transform: scale(1)
  }
}

.meta {
  display: none;
}

.fade-enter-active {
  transition: opacity 1.2s;
}

.fade-enter
  /* .fade-leave-to */
{
  opacity: 0;
}

.down-leave-active {
  display: none;
}

.down-enter-active {
  transition: .2s cubic-bezier(1, 0, 1, 1);
}

.down-enter,
.down-leave-to {
  transform: scale(3);
  opacity: 0;
}

.down-leave-active {
  display: none;
}

.fadefast-enter-active,
.fadefast-leave-active {
  transition: opacity .2s;
}

.fadefast-enter,
.fadefast-leave-to {
  opacity: 0;
}

.first-letter-big {
  text-transform: lowercase;
}

.first-letter-big *:first-letter {
  text-transform: uppercase;
}

.serach_list {
  background: #fff;
  user-select: none;
  position: absolute;
  /* cursor: pointer; */
  box-shadow: 0 11px 40px -2px #00000050;
  border-radius: 0 0 3px;
  overflow-y: scroll;
  border: 1px solid #ccc;
  border-top: none;
  max-height: 300px;
  z-index: 9;
}

.serach_list > .item {
  padding: 2px 10px;
  cursor: pointer;
}

.serach_list > .item:hover {
  color: #31b647;
  background: #f1f1f1;
}

.b-fluid {
  width: 100%;
  border-radius: 3px;
}

.search-in {
  border: 1px solid transparent;
  border-bottom: 2px solid #eee;
  border-bottom-width: 2px;
  transition: .3s;
}

.f-content-active {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.field-city {
  position: relative;
}

.field-city.inside-active {

}

.div-input {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
  user-select: none;
  padding: 5px 12px;
  transition: .2s;
  position: relative;
}

.div-input.f-content-active {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.disabled .div-input {
  opacity: .5;
}

@keyframes pulse-text {
  from, to {
    transform: scale(1);
  }
  20% {
    transform: scale(1.2);
  }
  30% {
    transform: scale(1);
  }
  40% {
    transform: scale(1.2);
  }
}

@keyframes pulse {
  from, to {
    box-shadow: 0 0 0px #31b647;
    border-color: initial;
  }
  50% {
    box-shadow: 0 0 10px #31b647;
    border-color: #31b647;
  }
}

.now-access .div-input {
  animation: pulse .5s cubic-bezier(1, -0.08, 0.22, 1.51);
}

.now-access .div-input:hover {
  background: #f5f5f5;
}

@keyframes brilliance {
  100% {
    transform: rotateZ(60deg) translate(1em, -9em);
  }
}

.btn-finaly {
  position: relative;
  overflow: hidden;
}

.btn-finaly:after {
  animation: brilliance 1s infinite alternate;
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  bottom: -50%;
  left: -50%;
  transform: rotateZ(60deg) translate(-5em, 7.5em);
  background: linear-gradient(transparent, #ffffff61, transparent);
}

.b-field-title {
  font-family: 'Proxima Nova Bold';
  margin-bottom: 10px;
}

.input-arrow {
  position: absolute;
  top: 50%;
  right: 9px;
  margin-top: -1px;
  width: 0;
  height: 0;
  border-top: 4px solid #6e6e6e;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  user-select: none;
  transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
}

.btn-by-type {
  padding: 10px;
  user-select: none;
  cursor: pointer;
  text-align: center;
  box-shadow: 0 5px 5px #ddd;
  background: #fff;
  border-radius: 4px;
  transition: .2s;
}

.btn-by-type:not(.active):hover {
  box-shadow: 0 1px 5px #ddd;
  background: #fafafa;
}

.btn-by-type.active {
  padding: 10px;
  box-shadow: inset 0 5px 5px #0000000f;
  cursor: default;
  font-family: 'Proxima Nova Bold', sans-serif;
  background: #4caf50;
  color: #fff;
}

h3 a {
  color: #252732;
  transition: .1s;
  font-family: 'Proxima Nova Bold';
}

h3 a:hover {
  color: #ff6d45;
}

.product-img {
  position: relative;
}

.label-product {
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  margin: 7px;
  user-select: none;
}

.label-class,
.label-cart {
  border-radius: 2px;
  padding: 5px 10px;
  display: inline-block;
  color: #fff !important;
  box-shadow: 0 3px 3px #0000000f;
}

.label-cart {
  /*background-color: #4caf50;*/
  text-shadow: 0 0 3px #000;
  box-shadow: none;
}

@media screen and (max-width: 900px) {
  h1 {
    font-size: 138%;
  }
}

.container.block {
  padding-top: 40px;
  padding-bottom: 40px;
}

.menu_top-link-phone {
  padding: 8px !important;
}

.menu_top-link-phone a {
  /* background: #0f78d6; */
  padding: 7px 15px !important;
  border-radius: 1px;
  font-family: 'Proxima Nova Bold';
}

.menu_top-link-phone a:hover {
  background-color: #0f78d6 !important;
  color: #fff !important;
}

.form-loader,
.preloader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #fff;
  z-index: 999;
  opacity: .8;
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-loader:after {
  position: fixed;
  animation: spinner .8s infinite linear;
  content: '';
  width: 60px;
  height: 60px;
  left: calc(50% - 15px);
  top: calc(50% - 15px);
  border-radius: 50%;
  border: 7px solid;
  border-color: transparent #00a3fb #00a3fb;
}

.preloader:after {
  position: absolute;
  animation: spinner .8s infinite linear;
  content: '';
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 3px solid;
  border-color: transparent #90A4AE #90A4AE;
}

.product_price {
  background: #4CAF50;
  color: #fff;
  padding: 5px 10px;
  width: max-content;
  border-radius: 2px;
  user-select: none;
  margin: 15px 0;
  box-shadow: 0 3px 3px #0000000f;
}

.product_lead {
  text-align: left;
  font-size: 20px;
  font-weight: 500;
}

.product_desc {
  color: #999;
  font-weight: 400;
  font-size: 15px;
  margin: 10px 0;
  display: block;
}

.market_footer_desc {
  font-size: 14px;
  color: #666;
  text-align: left;
  margin-top: 30px;
}

.market_thumbs {
  overflow: hidden;
  background: #f5f5f5;
}

.thumb_block {
  width: 100px;
  height: 73px;
  display: inline-block;
  padding: 10px;
  overflow: hidden;
  transition: .1s;
}

.thumb_block.active {
  background: #1e719624;
}

.thumb_sub_block {
  overflow: hidden;
  height: 100%;
  width: 100%;
}

.thumbs_container {
  font-size: 0;
  line-height: 0;
  transition: .1s;
}

.discount_block {
  border: 1px solid #eee;
  padding: 20px 30px;
  margin-bottom: 15px;
  box-shadow: 0 3px 3px #00000005;
  position: relative;
}

.discount_block input[type=checkbox] {
  position: absolute;
  z-index: -1;
  opacity: 0;
  margin: 10px 0 0 20px;
}

.discount_block input[type=checkbox] + label {
  position: relative;
  padding: 0 0 0 30px;
  cursor: pointer;
  font-family: 'Proxima Nova Bold';
}

.discount_block input[type=checkbox] + label:before {
  background: #fff;
  border-color: #ff6d45;
  border: 1px solid #ddd;
  content: '';
  position: absolute;
  top: 4px;
  left: 3px;
  width: 15px;
  height: 15px;
  transition: .1s;
  border-radius: 2px;
}

.discount_block input[type=checkbox] + label:after {
  content: '';
  position: absolute;
  left: 6px;
  top: 4px;
  width: 8px;
  height: 15px;
}

.discount_block input[type=checkbox]:checked + label:before {
  background: #fff;
  border-color: #ff6d45;
}

.discount_block input[type=checkbox]:hover + label:before {
  background: #ffffff;
  border: 1px solid #ddd;
  border-color: #ff6d45;
}

.discount_block input[type=checkbox]:checked + label:after {
  left: 8px;
  top: 0px;
  transform: rotate(45deg);
  border-bottom: 3px solid #ff6d45;
  border-right: 3px solid #ff6d45;
  transition: .1s;
}

.discount_block input:focus + label:before {
}

.cart-notice-block {
  z-index: 9;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 21px 30px;
  width: 100%;
}

.cart-notice-text {
  font-size: 15px;
  width: max-content;
  background: #4CAF50;
  color: #fff;
  padding: 13px 30px 13px 45px;
  box-shadow: 0 9px 8px -2px #4caf5073;
  border-radius: 3px;
  user-select: none;
  cursor: pointer;
  position: relative;
  transition: .1s;
  margin: 0 auto;
}

.cart-notice-text:hover {
  background: #49bd46;
}

.cart-notice-text:active {
  background: #4ec34a;
  box-shadow: 0 4px 4px -2px #4caf5073;
}

.cart-notice-icon {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.marker-list {
  padding-left: 15px;
  margin-top: 15px;
}

.marker-list li {
  position: relative;
  list-style: none;
}

.marker-list li:not(:last-child) {
  margin-bottom: 5px;
}

.marker-list li:before {
  content: '';
  width: 3px;
  height: 80%;
  background: #ff6d45;
  position: absolute;
  left: -15px;
  top: 10%;
}

.v-modal-container {
  background-color: rgba(0, 0, 0, 0.45);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
}

.v-modal-body {
  padding: 50px;
  padding-bottom: 0;
  box-shadow: 0 3px 30px rgba(0, 0, 0, 0.5);
  background: #fff;
  width: 500px;
  max-width: 90%;
  max-height: 90%;
  overflow-y: auto;
  position: relative;
  /* padding-bottom: 70px; */
  border-radius: 3px;
}

.v-modal-header {
  padding-bottom: 35px;
}

.v-modal-header * {
  font-family: 'Proxima Nova Regular';
}

.v-modal-content {

  font-size: 17px;
}

.close-block {
  /* position: absolute; */
  bottom: 0;
  left: 0;
  padding: 15px;
  text-align: center;
  width: 100%;
  color: #bbb;
  cursor: pointer;
  transition: .1s;
}

.vk-login-block {}

.vk-login-btn {
  width: max-content;
  background: #4a76a8;
  color: #fff;
  padding: 8px 30px;
  margin: 0 auto;
  margin-top: 30px;
  border-radius: 3px;
  user-select: none;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.vk-login-btn:hover {
  background-color: #6890c1;
}

.close-block:hover {
  color: #F44336;
}

.clickable {
  border-bottom: 1px dashed;
  cursor: pointer;
}

.clickable:hover {
  color: #d13b12;
}

.pulse-anim {
  animation: pulse-bg 1s ease-in-out;
}

.discount-benefit {
  background: rgba(76, 175, 80, 0.1);
  color: rgba(76, 175, 80, 1);
  border-radius: 3px;
  padding: 0px 9px;
  display: inline-block;
}

.btn-form-promo {
  background: #fff;
  border: none;
  height: 100%;
  width: 100%;
  background: #4caf50;
  color: #fff;
  cursor: pointer;
  user-select: none;
  border-radius: 3px;
  transition: .1s;
}

.btn-form-promo:hover {
  background: #8BC34A;
}

.btn-form-promo.disabled {
  cursor: default;
  background: #eee;
  color: #333;
}

@keyframes spinner {
  100% {
    transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes pulse-bg {
  10% {
    background-color: #ffeb3b2e;
  }
  100% {
    background-color: #fff;
  }
}

@media screen and (max-width: 900px) {
  .menu_top-link-phone a {
    padding: 9.5px !important;
  }

  .cart-notice-text {
    margin: inherit;
  }
  .v-modal-body {
    padding: 30px;
    /* padding-bottom: 70px; */
  }
  .v-modal-header {
    padding-bottom: 15px;
  }
}

.slick-slider .slider-item-nav {
  cursor: pointer;
  user-select: none;
  border: 2px solid transparent;
  margin-bottom: 2px;
}

.slick-slider .slider-item-nav:hover {
  border-color: #4caf50;
}

.slick-slider .slider-item-nav img {
  height: auto;
}

.tabs-container {
  border-bottom: 1px solid #eee;
}

.tabs-container .tab-item {
  padding: 5px 20px;
  display: inline-block;
  user-select: none;
  cursor: pointer;
  font-size: initial;
  transition: .1s;
  color: #2E7D32;
  border-radius: 3px;
}

.tabs-container .tab-item:hover {
  background-color: #ECEFF1;
}
.tabs-container .tab-item.active {
  background-color: #E8F5E9;
  color: #2E7D32;
}

.content.market {
  position: relative;
  float: none !important;
}

.product-progress-container {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 9;
  background-color: #fff;
  padding: 10px 20px;
  border-bottom: 1px solid transparent;
  transition: .5s;
}

.product-progress-container.on-shadow {
  box-shadow: 0 1rem 1rem -11px rgba(0,0,0,.15);
  border-color: #eee;
}

.product-progress-bar {
  height: 10px;
  background: #ECEFF1;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
}

.product-progress-line {
  height: 100%;
  background-color: #8bc34a;
  transition: .1s ease-in;
}

.product-progress-bar-b {
  position: relative;
}

.product-progress-is-full:after {
  content: '';
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 3px;
  top: 0;
  left: 0;
  animation: pulse-progress .5s cubic-bezier(.24, 0, .38, 1);
}

@keyframes pulse-progress {
  from {
    box-shadow: 0 0 0 0 rgba(76,175,80,.5)
  }

  to {
    box-shadow: 0 0 0 10px transparent
  }
}

.privilege-container {
  padding: 0 20px 20px;
}

.privilege-item {

}

.privilege-title a {
  color: #1976D2;
  font-size: 90%;
  font-family: 'Proxima Nova Bold';
}
.privilege-title i {
  color: #1976D2;
  opacity: .6;
}

.privilege-description {

}

.faq-title {
  font-family: 'Proxima Nova Bold';
  margin-bottom: 10px;
  font-size: 120%;
  line-height: 1.2;
}

.faq-title i {
  color: #31b647;
}

.faq-answer {

}

.faq-item:not(:last-child) {
  margin-bottom: 25px;
}

.smartphone-container {
  position: relative;
  max-width: 250px;
  margin: 0 auto;
}

.smartphone-bg {
  position: absolute;
  top: 21.3%;
  left: 7%;
  width: 85.8%;
  height: 61.9%;
  background: #fff;
  border-bottom: 1px solid #eff0f1;
  box-shadow: inset 1px 1px 6px -5px #000;
  padding: 3%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  overflow: hidden;
}

.smartphone-message {
  padding: 3%;
  font-size: 100%;
  border-radius: 10px;
  width: 80%;
  line-height: 1.3;
  background: url(/messages-sprite.png);
  background-size: cover;
  transition: .2s;
  transform: translateY(1000px);
}

.smartphone-message:not(:last-child) {
  margin-bottom: 3%;
}

.smartphone-message p:not(:last-child) {
  margin: 0 0 6%;
}

.smartphone-message p:last-child {
  margin: 0;
}

.smartphone-message:nth-child(1) {
  height: 60.4%;
  animation: message-animation 6s cubic-bezier(.24, 0, .38, 1) infinite;
}

.smartphone-message:nth-child(2) {
  height: 18.4%;
  background-position-y: 80.8%;
  animation: message-animation 6s cubic-bezier(.24, 0, .38, 1) infinite;
  animation-delay: 1s;
}

.smartphone-message:nth-child(3) {
  height: 14.4%;
  background-position-y: 99.8%;
  animation: message-animation 6s cubic-bezier(.24, 0, .38, 1) infinite;
  animation-delay: 2s;
}

@keyframes message-animation {
  from {
    transform: translateY(1000px);
  }

  10% {
    transform: translateY(0);
  }

  70% {
    opacity: 1;
    transform: translateY(0);
  }

  75% {
    opacity: 0;
    transform: translateY(0);
  }

  to {
    opacity: 0;
    transform: translateY(1000px);
  }
}

.vk-user-block {
  display: flex;
  align-items: center;
  width: max-content;
  margin: 0 auto;
  border: 1px solid #eee;
  padding: 10px 20px;
  border-radius: 3px;
}

.vk-user-photo {
  width: 35px;
  border-radius: 50%;
  overflow: hidden;
}

.vk-username {
  font-family: 'Proxima Nova Bold';
  font-size: 90%;
  margin-right: 15px;
}

.vk-allow-messages-container {
  width: 184px;
  margin: 20px auto;
}

.reviews-item {
  display: flex;
  padding: 10px 0;
  gap: 15px;
}

.r-img-block {
  flex: 0 0 50px;
}

.r-img-block img {
  border-radius: 50%;
}

.r-text-block {
  font-size: 90%;
}

.r-link-b .r-link-profile {
  font-family: 'Proxima Nova Bold', sans-serif;
}

.r-link-post {
  font-size: 85%;
}

.r-link-b .r-link-post:hover {
  text-decoration: underline;
}

.btn-vk-reviews {
  background-color: #5181b8;
  color: #fff;
  padding: 7px 16px 8px;
  border-radius: 4px;
  font-size: 12.5px;
  transition: .1s;
  margin: 20px auto 0;
  display: block;
  width: max-content;
}

.btn-vk-reviews:hover {
  color: #fff;
  opacity: .88;
}

body {
  line-height: 1.3;
}


.toast-container {
  position: fixed;
  top: 51px;
  left: 0;
  z-index: 9;
  padding: 10px 20px;
  width: 100%;
}

.toast-item {
  width: 500px;
  max-width: 100%;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0rem 1rem -3px rgb(0 0 0 / 15%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  pointer-events: all;
}

.toast-content {
  padding: 10px 10px 10px 25px;
}

.toast-item i {
  border: none;
}

.toast-close-ic {
  font-size: 250%;
  padding: 10px 25px;
}

.toast-item:not(:last-child) {
  margin-bottom: 10px;
}

.toast-close-ic {
  cursor: pointer;
  user-select: none;
}


.fly-leave-active {
  display: none;
}

.fly-enter-active {
  transition: .25s ease-out;
}

.fly-enter-from,
.fly-leave-to {
  transform: translateY(5%);
  opacity: 0;
}

.fly-leave-active {
  transition: .25s ease-out;
}

.fly-fast-leave-active {
  display: none;
}

.fly-fast-enter-active {
  transition: .15s ease-out;
}

.fly-fast-enter-from,
.fly-fast-leave-to {
  transform: translateY(5%);
  opacity: 0;
}

.fly-fast-leave-active {
  transition: .15s ease-out;
}

.container {
  max-width: 1150px;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid #eee;
  opacity: 1;
}

.meta {
  display: block;
  margin: 0;
  background: #f9f9f9;
  padding: 0 20px;
}

@media screen and (min-width: 900px) {
  .meta {
    padding: 0 60px;
  }
}

.meta a {
  border-radius: 4px;
  line-height: 3;
  padding: 5px 6px;
  margin: 0;
  transition: all .3s cubic-bezier(.25,.8,.25,1);
  font-size: 85%;
  border: none;
  color: #000;
}

.meta a:hover {
  color: #31b647;
  text-decoration: none;
}

.btn-finally-container {
  position: relative;
}

.owl-carousel .slide-item {
  padding: 10px;
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.slider-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 3px 1px #0000001f;
  border-radius: 3px;
  border-bottom: 1px solid #eee;
  font-family: Proxima Nova Extra Bold;
}

</style>
